(() => {
  function init(root) {
  if (root.dataset.initialized) return;
  root.dataset.initialized = 'true';

  const $ = (selector) => root.querySelector(selector);
  const all = (selector) => [...root.querySelectorAll(selector)];
  const config = JSON.parse($('#weasy-food-config').textContent);
  const menus = {
    bovino: {
      name: 'Menu Bovino',
      title: 'Menu Bovino.',
      copy: 'Coração e língua de bovino (47%), batata-doce, arroz, água, fígado de bovino (5%), abobrinha, banha suína, alecrim desidratado, cloreto de sódio, óleo de girassol, extrato de alecrim, extrato de chá verde e concentrado de tocoferóis. Eventuais substitutivos: carne de bovino, abóbora, chuchu.'
    },
    frango: {
      name: 'Menu de Frango',
      title: 'Menu Frango.',
      copy: 'Moela de frango (50%), arroz, água, cenoura, abóbora, fígado de frango (5%), banha suína, cloreto de sódio, cúrcuma, óleo de girassol, extrato de alecrim, extrato de chá verde e concentrado de tocoferóis. Eventuais substitutivos: peito de frango, beterraba, batata-doce.'
    },
    suino: {
      name: 'Menu Suíno',
      title: 'Menu Suíno.',
      copy: 'Coração de suíno (48,5%), arroz, batata-doce, abóbora, fígado de suíno (7%), abobrinha, água, cloreto de sódio, banha suína, manjericão desidratado, óleo de girassol, extrato de alecrim, extrato de chá verde e concentrado de tocoferóis.'
    }
  };
  const sizes = ['250 g', '1 kg', '5 kg', '10 kg'];
  const boxDetails = {
    '5 kg': 'Caixa com 20 unidades de 250g',
    '10 kg': 'Caixa com 10 unidades de 1kg'
  };
  const money = new Intl.NumberFormat('pt-BR', {
    style: 'currency', currency: config.currency || 'BRL'
  });
  let flavor = 'bovino';
  let size = '250 g';
  let purchaseMode = 'subscription';
  let busy = false;

  const normalize = (value) => String(value || '').normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '').toLowerCase();

  function isSubscription(variant) {
    const optionValues = Array.isArray(variant.options) ? variant.options : [];
    const values = [...optionValues, variant.title];
    return values.some((value) => /\b(assinar|assinatura|mensal)\b/.test(normalize(value)));
  }

  function variantFor(menu, wantedSize, mode = purchaseMode) {
    const token = wantedSize.toLowerCase().replace(/\s/g, '');
    const flavorToken = normalize(menu);
    return (config.variants || []).find((variant) => {
      const title = normalize(variant.title);
      const compact = title.replace(/\s/g, '');
      const hasFlavor = new RegExp(`(^|[^a-z])${flavorToken}([^a-z]|$)`).test(title);
      const hasSize = new RegExp(`(^|[^0-9])${token}([^0-9]|$)`).test(compact);
      return hasFlavor && hasSize && (mode === 'subscription' ? isSubscription(variant) : !isSubscription(variant));
    });
  }

  function choice(wantedSize = size) {
    return variantFor(flavor, wantedSize);
  }

  function availableFor(wantedSize) {
    const variant = choice(wantedSize);
    return Boolean(variant && variant.available);
  }

  function chooseAvailableFlavor() {
    for (const candidate of [flavor, 'bovino', 'frango', 'suino']) {
      for (const candidateSize of sizes) {
        const variant = variantFor(candidate, candidateSize);
        if (variant && variant.available) {
          flavor = candidate;
          size = candidateSize;
          return;
        }
      }
    }
  }

  function message(value) {
    const element = $('#weasy-food-order-message');
    element.textContent = value;
    element.hidden = !value;
  }

  function update() {
    const hasSubscription = (config.variants || []).some((variant) => isSubscription(variant) && variant.available);
    if (purchaseMode === 'subscription' && !hasSubscription) purchaseMode = 'once';
    if (!availableFor(size)) chooseAvailableFlavor();
    all('[data-flavor]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.flavor === flavor));
    });
    all('[data-purchase-mode]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.purchaseMode === purchaseMode));
      button.disabled = button.dataset.purchaseMode === 'subscription' && !hasSubscription;
    });
    $('[data-subscription]').disabled = !hasSubscription;
    all('[data-size]').forEach((button) => {
      const thisSize = button.dataset.size;
      const variant = variantFor(flavor, thisSize);
      button.disabled = !availableFor(thisSize);
      button.setAttribute('aria-pressed', String(thisSize === size));
      const price = variant ? Number(variant.price) : null;
      button.querySelector('[data-price]').textContent = price === null
        ? 'Indisponível' : money.format(price / 100);
      const unitPrice = button.querySelector('[data-unit-price]');
      if (unitPrice) {
        const count = thisSize === '5 kg' ? 20 : 10;
        unitPrice.textContent = price === null ? 'Indisponível' : money.format(price / 100 / count);
      }
      const sizeImage = button.querySelector('[data-size-image]');
      if (sizeImage) sizeImage.src = variant?.image || config.images[flavor];
    });
    $('#order-image').src = config.images[flavor];
    $('#order-image').alt = menus[flavor].name;
    $('#selection-description').textContent = menus[flavor].copy;
    $('#selection-summary').textContent = `${menus[flavor].name} · ${size} · ${purchaseMode === 'subscription' ? 'Assinatura mensal' : 'Compra única'}`;
    const boxNote = $('#weasy-food-box-note');
    boxNote.textContent = boxDetails[size] || '';
    boxNote.hidden = !boxDetails[size];
    const selected = choice();
    $('#add-cart').disabled = busy || !selected || !selected.available;
    message('');
  }

  function select(nextFlavor, scroll) {
    if (!menus[nextFlavor]) return;
    flavor = nextFlavor;
    update();
    if (scroll) $('#pedido').scrollIntoView({
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  }

  all('[data-flavor]').forEach((button) => button.addEventListener('click', () => select(button.dataset.flavor)));
  all('[data-select]').forEach((button) => button.addEventListener('click', () => select(button.dataset.select, true)));
  all('[data-size]').forEach((button) => button.addEventListener('click', () => {
    size = button.dataset.size;
    update();
  }));
  all('[data-purchase-mode]').forEach((button) => button.addEventListener('click', () => {
    purchaseMode = button.dataset.purchaseMode;
    if (!availableFor(size)) chooseAvailableFlavor();
    update();
  }));
  $('[data-subscription]').addEventListener('click', () => {
    purchaseMode = 'subscription';
    if (!availableFor(size)) chooseAvailableFlavor();
    update();
    $('#pedido').scrollIntoView({
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  });

  all('[data-ingredient]').forEach((button) => button.addEventListener('click', () => {
    const key = button.dataset.ingredient;
    all('[data-ingredient]').forEach((tab) => tab.setAttribute('aria-pressed', String(tab === button)));
    $('#ingredient-image').src = config.images[`ingredientes-${key}`];
    $('#ingredient-image').alt = `Ingredientes e embalagem do ${menus[key].name}`;
    $('#ingredient-title').textContent = menus[key].title;
    $('#ingredient-copy').textContent = menus[key].copy;
  }));

  const stickyButton = $('[data-mobile-cta]');
  let orderInView = false;
  const orderObserver = new IntersectionObserver(([entry]) => {
    orderInView = entry.isIntersecting;
    stickyButton.textContent = orderInView ? 'Comprar agora ↗' : 'Escolher Menu ↗';
  }, { rootMargin: '0px 0px -80px 0px', threshold: 0.05 });
  orderObserver.observe($('#pedido'));
  stickyButton.addEventListener('click', (event) => {
    if (!orderInView) return;
    event.preventDefault();
    if ($('#add-cart').disabled) {
      message('Selecione uma opção disponível para comprar.');
      return;
    }
    $('#add-cart').click();
  });

  $('#add-cart').addEventListener('click', async () => {
    const selected = choice();
    if (!selected || !selected.available) {
      update();
      message('Esta opção está indisponível. Escolha outro Menu ou tamanho.');
      return;
    }
    busy = true;
    $('#add-cart').disabled = true;
    message('Preparando o checkout…');
    try {
      const response = await fetch(`${config.cartAddUrl}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: selected.id, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Falha ao adicionar itens');
      window.location.assign(config.checkoutUrl);
    } catch {
      busy = false;
      update();
      message('Não foi possível iniciar a compra. Tente novamente.');
    }
  });

  update();
  }

  document.querySelectorAll('[data-weasy-food]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-weasy-food]').forEach(init);
  });
})();
